export default function LocationsSection() {
  const handleGetDirections = () => {
    window.open('https://www.google.com/maps/search/Verde+Cocina+Juarez', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+526565551234';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* About Section */}
          <div>
            <h2 className="text-3xl font-bold mb-6">About Verde Cocina</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Plant-based dining at its finest. Verde Cocina proves that vegetarian and vegan food can be exciting, flavorful, and satisfying. Our innovative menu features creative dishes that even devoted meat-lovers rave about, using fresh, locally-sourced ingredients whenever possible.
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed">
              From our signature Buddha bowls packed with colorful vegetables and grains to our indulgent vegan desserts, every dish celebrates the natural flavors of plants. Whether you're vegetarian, vegan, or just looking to eat healthier, Verde Cocina offers a welcoming space to enjoy delicious, guilt-free food that's good for you and the planet.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-leaf-line text-green-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">100% Plant-Based</h3>
                  <p className="text-gray-600">Fully vegetarian and vegan menu with creative dishes</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-plant-line text-green-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Fresh Local Ingredients</h3>
                  <p className="text-gray-600">Sourced from local farms for maximum freshness and flavor</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-heart-line text-green-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Health-Conscious</h3>
                  <p className="text-gray-600">Nutritious meals that nourish body and soul</p>
                </div>
              </div>
            </div>
          </div>

          {/* Location Details */}
          <div>
            <div className="bg-gray-50 rounded-lg p-8 mb-6">
              <h3 className="text-2xl font-bold mb-6">Location & Hours</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-map-pin-line text-green-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Address</h4>
                    <p className="text-gray-700">Av. Paseo de la Victoria 3890<br/>Col. Partido Iglesias<br/>Juárez, Chihuahua</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-phone-line text-green-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Phone</h4>
                    <a href="tel:+526565551234" className="text-green-600 hover:underline">
                      +52 656 555 1234
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-time-line text-green-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-2">Hours</h4>
                    <div className="space-y-1 text-sm text-gray-700">
                      <p>Monday - Friday: 8:00 AM - 9:00 PM</p>
                      <p>Saturday: 9:00 AM - 9:00 PM</p>
                      <p>Sunday: 9:00 AM - 6:00 PM</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 flex gap-4">
                <button
                  onClick={handleGetDirections}
                  className="flex-1 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Directions
                </button>
                <button
                  onClick={handleCall}
                  className="flex-1 border-2 border-green-600 text-green-600 px-6 py-3 rounded-lg hover:bg-green-50 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  Call Now
                </button>
              </div>
            </div>
            
            {/* Map */}
            <div className="rounded-lg overflow-hidden h-[300px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.2!2d-106.44!3d31.75!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDQ1JzAwLjAiTiAxMDbCsDI2JzI0LjAiVw!5e0!3m2!1sen!2smx!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Verde Cocina Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
